import { Task } from '@/types/tasks';
import { createContext } from 'react';

export type Source = 'task' | 'list' | null;

interface RegistrationsContextType {
  filteredRegistrations: Task[];
  currentRegistrationId: string | null;
  setFilteredRegistrations: (tasks: Task[]) => void;
  setCurrentRegistrationId: (id: string | null) => void;
  getNextRegistration: (currentId: string) => Task | null;
  source: Source;
  setSource: (src: Source) => void;
}

export const RegistrationsContext = createContext<RegistrationsContextType | null>(null);
